module.exports = __webpack_public_path__ + "static/img/tab3.395f550.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tab3.jpg
// module id = 3143
// module chunks = 1